
import Button from "../UI/Button";
import StyledHero from "./Hero.Module";
// import styles from "./Hero.module.css";



function Hero() {
    return (
        <StyledHero>
          {/* <div className={styles.container}> */}
          <div  className="container">
            <section  className="hero">
                <div  className="hero__left" >
                    <h1 >Covid ID</h1>
                    <h3 >Monitoring Perkembangan Covid</h3>
                    <p >Aplikasi Monitoring Covid-19 dan Media Informasi Up to Date, Semoga Bermanfaat.</p>
                    {/* <button className={styles.hero__button}>Vaccine</button> */}
                    <Button variant="vacine" full>Vaccine</Button>
                </div>

                

                <div className="hero__right">
                    <img  className="hero__image" src="https://media.discordapp.net/attachments/894919708938223657/961641500121370634/hero.jpg" alt="" />
                </div>
            </section>
        </div>
        {/* </div>  */}


        </StyledHero>
    );
  }


export default Hero;